<template>
    <footer class="bg-[#101010] text-white">
        <div class="border-b border-white/5 bg-gradient-to-r from-[#181818] via-[#222222] to-[#161616]">
            <div class="mx-auto grid max-w-7xl gap-8 px-5 py-10 md:grid-cols-[1fr_auto_auto] md:items-center lg:px-12">
                <div>
                    <h2 class="font-serif text-2xl uppercase md:text-3xl">
                        {{ t.footer.title }}
                    </h2>

                    <p class="mt-3 text-sm text-white/70">
                        {{ t.footer.subtitle }}
                    </p>
                </div>

                <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
                    <a
                        :href="whatsappLink"
                        target="_blank"
                        rel="noopener"
                        class="flex h-14 items-center justify-center rounded-xl border border-[#c8b79c]/40 px-8 text-sm uppercase tracking-wide transition hover:bg-white hover:text-black"
                    >
                        WhatsApp
                    </a>

                    <a
                        :href="telegramLink"
                        target="_blank"
                        rel="noopener"
                        class="flex h-14 items-center justify-center rounded-xl border border-[#c8b79c]/40 px-8 text-sm uppercase tracking-wide transition hover:bg-white hover:text-black"
                    >
                        Telegram
                    </a>
                </div>

                <div class="md:text-right">
                    <div class="text-sm uppercase tracking-wide text-white/45">
                        {{ t.footer.call }}
                    </div>

                    <a
                        :href="phoneLink"
                        class="mt-1 block font-serif text-2xl"
                    >
                        {{ phoneFormatted }}
                    </a>
                </div>
            </div>
        </div>

        <div class="bg-[#151515]">
            <div class="mx-auto flex max-w-7xl flex-col gap-6 px-5 py-6 md:flex-row md:items-center md:justify-between lg:px-12">
                <div class="flex flex-col gap-5 md:flex-row md:items-center">
                    <div class="flex items-center gap-3">
                        <IconLogo class="h-11 w-11"/>

                        <div class="font-serif text-base uppercase leading-none tracking-wide">
                            Batumi<br>
                            Center House
                        </div>
                    </div>

                    <div class="grid grid-cols-2 gap-2 md:ml-6 md:flex md:items-center">
                        <a
                            href="https://www.myhome.ge/pr/24785413/iyideba-4-otaxiani-kerdzo-saxli-batumshi/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="MyHome.ge"
                            class="flex h-10 items-center justify-center rounded-xl border border-white/10  px-3 transition bg-white md:w-32"
                        >
                            <img
                                src="@img/platforms/myhome.png"
                                alt="MyHome.ge"
                                loading="lazy"
                                decoding="async"
                                class="max-h-6 max-w-[100px] object-contain"
                            >
                        </a>

                        <a
                            href="https://home.ss.ge/default/udzravi-qoneba/35514309"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="SS.ge"
                            class="flex h-10 items-center justify-center rounded-xl border border-white/10  px-3 transition bg-white md:w-32"
                        >
                            <img
                                src="@img/platforms/ssge.png"
                                alt="SS.ge"
                                loading="lazy"
                                decoding="async"
                                class="max-h-6 max-w-[100px] object-contain"
                            >
                        </a>

                        <a
                            href="https://korter.ge/iyideba-kerdzo-saxlebi-batumshi/642954"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Korter.ge"
                            class="col-span-2 flex h-10 items-center justify-center rounded-xl border border-white/10  px-3 transition bg-white md:col-span-1 md:w-32"
                        >
                            <img
                                src="@img/platforms/korter.png"
                                alt="Korter.ge"
                                loading="lazy"
                                decoding="async"
                                class="max-h-6 max-w-[100px] object-contain"
                            >
                        </a>
                    </div>
                </div>

                <a
                    href="https://x-devs.ru/"
                    target="_blank"
                    rel="noopener noreferrer"
                    :title="t.footer.made"
                    class="text-sm text-white/35"
                >
                    {{ t.footer.made }}
                </a>
            </div>
        </div>
    </footer>
</template>

<script>
import { homeTranslations } from "@js/i18n/home.js";

import IconLogo from "@js/components/Icons/IconLogo.vue";

export default {
    name: 'FooterSection',

    components: {
        IconLogo,
    },

    data() {
        return {
            whatsappPhone: '995595156424',
            telegramUsername: 'AniSimnn',
            phoneFormatted: '+995 595 15 64 24',
        };
    },

    computed: {
        locale() {
            return this.$page.props.locale || 'ru';
        },

        t() {
            return homeTranslations[this.locale] || homeTranslations.ru;
        },

        whatsappLink() {
            return `https://wa.me/${this.whatsappPhone}`;
        },

        telegramLink() {
            return `https://t.me/${this.telegramUsername}`;
        },

        phoneLink() {
            return `tel:+${this.whatsappPhone}`;
        },
    },
};
</script>
